import React from "react";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const FormContext = React.createContext(null);
const initValidationResultType = {
    isValid: () => true,
    getErrors: () => ({})
};
export const useForm = (props) => {
    const { validator, object, mode } = props;
    const paths = React.useRef(new Map());
    const validationResults = React.useRef(initValidationResultType);
    const isSubmitAttempted = React.useRef(false);
    const subscribers = React.useRef(new Set());
    const pendingValidation = React.useRef(undefined);
    React.useEffect(() => {
        pendingValidation.current?.(object);
        pendingValidation.current = undefined;
    }, [object]);
    const publish = () => {
        subscribers.current.forEach(s => s());
    };
    const refFn = () => ({
        reset: () => void 0,
        isValid: () => {
            if (!validator)
                return true;
            if (validationResults.current)
                return validationResults.current.isValid();
            return true;
        },
        getErrors: () => {
            return validationResults.current?.getErrors() || {};
        },
        validate: () => {
            validateFn(object);
            return validationResults.current;
        },
        submit: () => {
            isSubmitAttempted.current = true;
            validateFn(object);
            return validationResults.current;
        }
    });
    const subscribe = (callback) => {
        subscribers.current.add(callback);
        return () => subscribers.current.delete(callback);
    };
    const _getErrors = React.useCallback(() => {
        const errors = validationResults.current?.getErrors();
        if (!errors)
            return [];
        const keys = Object.keys(errors).map(x => errors[x]).flatMap(x => x);
        return keys;
    }, []);
    const validateFn = React.useCallback((o) => {
        if (!validator)
            return;
        // const pathArray = Array.from(paths.current).map(([path]) => path);
        const result = o instanceof Array ? validator.validateArray(o) : validator.validate(o);
        validationResults.current = result;
        publish();
        // if (o instanceof Array) {
        //     const result = validator.validateArray(o, pathArray);
        //     validationResults.current = result;
        //     publish();
        // } else {
        //     const result = validator.validate(o, pathArray);
        //     validationResults.current = result;
        //     publish();
        // }
    }, [validator]);
    const _validate = React.useCallback(() => {
        mode === "react" ? pendingValidation.current = validateFn : validateFn(object);
        // mode === "react" ? setTimeout(() => validateFn(object), 0) : validateFn(object);
    }, [mode, object, validateFn]);
    const _isSubmitAttempted = React.useCallback(() => isSubmitAttempted.current, []);
    const _register = React.useCallback((path) => paths.current.set(path, false), []);
    const _unRegister = React.useCallback((path) => paths.current.delete(path), []);
    const _setTouched = React.useCallback((path) => { paths.current.set(path, true); }, []);
    const _isTouched = React.useCallback((path) => paths.current.get(path), []);
    const _hasPathError = React.useCallback((path) => {
        const errors = validationResults.current?.getErrors();
        if (!errors)
            return false;
        for (const key in errors) {
            if (key.startsWith(path))
                return true;
        }
        return false;
    }, []);
    const _getPropError = React.useCallback((path) => {
        if (_isTouched(path) || _isSubmitAttempted()) {
            const error = validationResults.current?.getErrors()?.[path]?.[0];
            return error;
        }
        return undefined;
    }, [_isSubmitAttempted, _isTouched]);
    return [refFn, { subscribe, _getErrors, _hasPathError, _validate: _validate, _register, _unRegister, _setTouched, _isTouched, _path: "", _getPropError, _isSubmitAttempted }];
};
// export const getProp = (obj: any, path: string) => {
//     const parts = path.replaceAll("[", "").replace("]", "").split(".").filter(x => x);
//     let result: any = obj;
//     for (let i = 0; i < parts.length; i++) {
//         result = result?.[parts[i]];
//     }
//     if (!result) return result;
//     if ("messages" in result) return result.messages;
//     return result;
// }
